const ALLOWED_TAGS = ['b', 'i', 'u', 'strong', 'em', 'ol', 'ul', 'li', 'p', 'div', 'br', 'span', 'a'];

export function safeHref(href: string): string | null {
  const trimmed = String(href || '').trim();
  if (!trimmed) return null;
  let candidate = trimmed;
  if (!/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(candidate)) {
    candidate = `https://${candidate}`;
  }
  try {
    const parsed = new URL(candidate);
    if (!['http:', 'https:', 'mailto:'].includes(parsed.protocol)) {
      return null;
    }
    return parsed.href;
  } catch {
    return null;
  }
}

export function sanitizeHtml(html: string): string {
  if (!html || typeof html !== 'string') return '';
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const walk = (node: Node): Node | null => {
    if (node.nodeType === Node.TEXT_NODE) return node;
    if (node.nodeType !== Node.ELEMENT_NODE) return null;
    const el = node as Element;
    const tag = el.tagName.toLowerCase();
    if (!ALLOWED_TAGS.includes(tag)) return null;
    const href = tag === 'a' ? safeHref(el.getAttribute('href') || '') : null;
    Array.from(el.attributes).forEach((attr) => {
      if (tag === 'span' && (attr.name === 'data-user-id' || attr.name === 'data-user-name' || attr.name === 'class')) {
        return;
      }
      el.removeAttribute(attr.name);
    });
    const children = Array.from(node.childNodes).map(walk).filter(Boolean) as Node[];
    if (tag === 'a' && !href) {
      const span = doc.createElement('span');
      span.replaceChildren(...children);
      return span;
    }
    el.replaceChildren(...children);
    if (tag === 'a' && href) {
      el.setAttribute('href', href);
      el.setAttribute('target', '_blank');
      el.setAttribute('rel', 'noopener noreferrer');
    }
    return el;
  };
  const children = Array.from(doc.body.childNodes).map(walk).filter(Boolean) as Node[];
  doc.body.replaceChildren(...children);
  return doc.body.innerHTML;
}

export function isEmptyHtml(html: string): boolean {
  if (!html || typeof html !== 'string') return true;
  const text = html
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\u00A0/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return !text;
}
